import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

export const GQL_SCORM_MODULES = typedGql('query', { scalars })({
  scormModules: {
    id: true,
    title: true,
    description: true,
    scormVersion: true,
    launchUrl: true,
    status: true,
    createdAt: true,
    updatedAt: true,
    sizeBytes: true,
  },
})

export const GQL_SCORM_MODULE = typedGql('query', { scalars })({
  scormModule: [
    { id: $('id', 'ID!') },
    {
      id: true,
      title: true,
      scormVersion: true,
      launchUrl: true,
      status: true,
    },
  ],
})

export const GQL_DELETE_SCORM_MODULE = typedGql('mutation')({
  deleteScormModule: [{ id: $('id', 'ID!') }, true],
})
